<template>
  <div>
    <border-style-options
      :mode="mode"
      :border-style="selected.borderStyle || 'none'"
      :border-color="selected.borderColor || null"
      :border-width="selected.borderWidth || 0"
      :border-radius="selected.borderRadius || 0"
      :border-position="selected.borderPosition || {}"
      :show-border-position="true"
      :update-prop-function="selected.updateProp"
    />
    <div class="divider mt-2" />

    <div class="row">
      <div class="col">
        <h6>{{ $t('elements.properties.shadow.label') }}</h6>
      </div>
      <div class="col-12">
        <cvt-radio-group orientation="horizontal" :initial-value="shadow">
          <cvt-radio-button
            size="md"
            value="shadow-none"
            :shape="RadioButtonShape"
            @radioClick="(value) => shadow = value"
          >
            {{ $t('elements.properties.option.none') }}
          </cvt-radio-button>
          <cvt-radio-button
            size="md"
            value="shadow"
            :shape="RadioButtonShape"
            @radioClick="(value) => shadow = value"
          >
            {{ $t('elements.properties.shadow.normal') }}
          </cvt-radio-button>
          <cvt-radio-button
            size="md"
            value="shadow-lg"
            :shape="RadioButtonShape"
            @radioClick="(value) => shadow = value"
          >
            {{ $t('elements.properties.shadow.deep') }}
          </cvt-radio-button>
        </cvt-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import { mapGetters, mapState } from "vuex";
import * as getters from "@/js/store/modules/getters";
import BorderStyleOptions from './BorderStyleOptions.vue'

export default {
  name: "CCardGlobalStyleOption",
  components: {
    BorderStyleOptions,
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
  },
  computed: {
    ...mapGetters({
      selected: getters.SELECTOR_SELECTED
    }),
    ...mapState('globalTheme', {
      RadioButtonShape: ({ globalTheme }) =>
        globalTheme.RadioButtonShape !== undefined
          ? globalTheme.RadioButtonShape
          : '',
    }),
    shadow: {
      get() {
        return _.get(this, 'selected.itemStyles.shadow', "")
      },
      set(value) {
        this.selected.updateProp('itemStyles/shadow', value)
      }
    },
  },
};
</script>

<style scoped>

</style>